import Image from 'next/image'
import { useId } from 'react'
import { cn } from '~/utils/cn'

const GameEvent = ({
	title,
	image,
	state,
	openStateVerb,
	closeStateVerb,
	humanReadableCountdown,
	countdown,
	onClick,
}: {
	title: string
	image: string | null
	state: boolean
	openStateVerb: string
	closeStateVerb: string
	humanReadableCountdown: string
	countdown: string
	onClick: () => void
}) => {
	const titleId = useId()

	const showState = openStateVerb !== closeStateVerb

	return (
		<button
			type="button"
			onClick={onClick}
			aria-haspopup="dialog"
			className="h-72 rounded-lg text-white relative bg-black md:scale-on-hover group text-left overflow-hidden cursor-pointer"
		>
			{image ? (
				<Image
					src={image}
					alt=""
					fill={true}
					quality={100}
					className="object-cover object-bottom rounded-lg overflow-hidden opacity-60"
				/>
			) : null}
			<div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg" />
			<div className={cn('rounded-lg text-white relative p-5 h-full flex flex-col justify-between', showState && 'pb-12')}>
				<div>
					<h2
						id={titleId}
						className="font-bold text-2xl drop-shadow-sm truncate text-ellipsis text-balance"
					>
						{title}
					</h2>
					<p
						role="status"
						aria-live="polite"
						aria-describedby={titleId}
						className="drop-shadow-sm"
					>
						{`${state ? closeStateVerb : openStateVerb} ${humanReadableCountdown}`}
					</p>
				</div>
				<div>
					<p
						role="timer"
						aria-label={`Countdown until ${title}`}
						className="text-4xl font-black w-full text-right drop-shadow-sm tabular-nums"
					>
						{countdown}
					</p>
					<p className="text-xs w-full text-right drop-shadow-sm">
						til next state
					</p>
					{showState ? (
						<div
							className={cn(
								'absolute bottom-0 left-0 rounded-b-lg font-black text-2xl w-full text-right px-2',
								state ? 'bg-green-900' : 'bg-red-900',
							)}
						>
							{state ? openStateVerb : closeStateVerb}
						</div>
					) : null}
				</div>
			</div>
			<div className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg">
				<span className="text-white font-bold text-lg drop-shadow-sm">
					Click to View Schedule
				</span>
			</div>
		</button>
	)
}

export default GameEvent
